import React from 'react';
import { Circle, Label, LeftArrow, RightArrow, Wrapper } from './styles';

interface FlowButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
}

const FlowButton: React.FC<FlowButtonProps> = ({ text, ...rest }) => (
  <Wrapper type="button" {...rest}>
    <LeftArrow aria-hidden="true" />
    <Label>{text}</Label>
    <Circle />
    <RightArrow aria-hidden="true" />
  </Wrapper>
);

export default FlowButton;
